import { createTheme } from "@mui/material";
import { getEnvType } from "services";

declare module "@mui/material/styles" {
  interface Theme {
    text: {
      red: string;
      blue: string;
      green: string;
    };
    frames: {
      normal: string;
      border: string;
      text: string;
      contrastText: string;
      bar: string;
    };
    labels: {
      normal: string;
      border: string;
      text: string;
      required: string;
    };
    fields: {
      normal: string;
      disabled: string;
      text: string;
      border: string;
    };
    selects: {
      required: string;
    };
    buttons: {
      normal: string;
      file: string;
      cancel: string;
      info: string;
      text: string;
      hover: {
        normal: string;
        file: string;
        cancel: string;
        info: string;
        text: string;
      };
    };
    tables: {
      header: string;
      text: string;
      row: string;
      hover: string;
      select: string;
    };
    modals: {
      backdrop: string;
      text: string;
    };
  }
  interface ThemeOptions {
    text?: {
      red: string;
      blue: string;
      green: string;
    };
    frames?: {
      normal: string;
      border: string;
      text: string;
      contrastText: string;
      bar: string;
    };
    labels?: {
      normal: string;
      border: string;
      text: string;
      required: string;
    };
    fields?: {
      normal: string;
      disabled: string;
      text: string;
      border: string;
    };
    selects?: {
      required: string;
    };
    buttons?: {
      normal: string;
      file: string;
      cancel: string;
      info: string;
      text: string;
      hover: {
        normal: string;
        file: string;
        cancel: string;
        info: string;
        text: string;
      };
    };
    tables?: {
      header: string;
      text: string;
      row: string;
      hover: string;
      select: string;
    };
    modals?: {
      backdrop: string;
      text: string;
    };
  }
}

const appBar = () => {
  const envType = getEnvType();
  if (envType === "production") return "#095B9E";
  if (envType === "staging") return "#097E0B";
  return "#5B099E";
};

export const STheme = createTheme({
  palette: {
    text: {
      primary: "#111111",
    },
  },
  typography: {
    fontSize: 13,
    fontFamily: ["Roboto", '"Helvetica Neue"', "Arial", "sans-serif"].join(","),
  },
  text: {
    red: "#FF0000",
    blue: "#0000FF",
    green: "#008000",
  },
  frames: {
    normal: "#F0F0F0",
    border: "#C2C2C2",
    text: "#2A2F30",
    contrastText: "#F0F0F0",
    bar: appBar(),
  },
  labels: {
    normal: "#F9F9F9",
    border: "#B9C0C2",
    text: "#111111",
    required: "#d32f2f",
  },
  fields: {
    normal: "#FFFFFF",
    disabled: "#DDDDDD",
    text: "#111111",
    border: "#B9C0C2",
  },
  selects: {
    required: "#d32f2f",
  },
  buttons: {
    normal: "#09589E",
    file: "#008838",
    cancel: "#E32434",
    info: "#1A759F",
    text: "#FFFFFF",
    hover: {
      normal: "#07467E",
      file: "#005523",
      cancel: "#bc1826",
      info: "#156082",
      text: "#FFFFFF",
    },
  },
  tables: {
    header: "#F9F9F9",
    text: "#111111",
    row: "#FFFFFF",
    hover: "#EEEEEE",
    select: "#DDDDDD",
  },
  modals: {
    backdrop: "rgba(0,0,0,0.03)",
    text: "#07467E",
  },
});

export const STabTheme = createTheme(
  {
    components: {
      MuiTabs: {
        styleOverrides: {
          root: {
            minHeight: "auto",
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            minHeight: "auto",
            paddingTop: "6px",
            paddingBottom: "0px",
          },
        },
      },
    },
  },
  { ...STheme }
);
